import React, { Component, PropTypes } from 'react';
import shouldPureComponentUpdate from 'react-pure-render/function';
import InlineSVG from 'svg-inline-react';
import searchIcon from './search.svg';
import './SearchUnitHeader.scss';

export default class SearchUnitHeader extends Component {
  static propTypes = {
    resetSearchForm: PropTypes.func,
    showIcon: PropTypes.bool,
    title: PropTypes.string,
  };

  static defaultProps = {
    resetSearchForm: null,
    showIcon: false,
    title: 'Search holidays',
  };

  shouldComponentUpdate = shouldPureComponentUpdate;

  handleResetClick = (event) => {
    const { resetSearchForm } = this.props;
    event.preventDefault();
    resetSearchForm();
  };

  render() {
    const { resetSearchForm, title, showIcon } = this.props;
    return (
      <div className="search-unit-header">
        { !!showIcon && <InlineSVG src={searchIcon} className="search-unit-header__icon" /> }
        { !!resetSearchForm && <a href="#" className="search-unit-header__reset" onClick={this.handleResetClick}>reset</a>}
        <h2 className="search-unit-header__title">{title}</h2>
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/SearchUnitHeader/SearchUnitHeader.jsx
 **/